import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'alphanumericSpace'})
export class AlphanumericSpacePipe implements PipeTransform {
    transform(value: string, args: any[] = []): string {
        return value ? String(value).replace(/([a-z]+)(\d+)/g, '$1 $2') : '';
    }
}
